export const COMPONENT_BODY_CLASSNAME = 'p-os-grid';
